import { useEffect } from 'react'
import { usePostHog } from '@posthog/react'
import { useAuth } from '../contexts/AuthContext'
import { POSTHOG_PROJECT_TOKEN } from '../posthog'

const getUserId = (user) => {
  return user?._id || user?.id || user?.email || user?.username || null
}

const PostHogAuthSync = () => {
  const posthog = usePostHog()
  const { authenticated, user, isLoading } = useAuth()

  useEffect(() => {
    if (!POSTHOG_PROJECT_TOKEN || !posthog || isLoading) {
      return
    }

    if (!authenticated || !user) {
      posthog.reset()
      return
    }

    const userId = getUserId(user)
    if (!userId) {
      return
    }

    posthog.identify(String(userId), {
      email: user.email,
      name: user.name || user.username,
      username: user.username,
    })
  }, [authenticated, isLoading, posthog, user])

  return null
}

export default PostHogAuthSync
